$(function () {
    require('owl.carousel');

    $('.testimonial-slider').owlCarousel({
        loop: true,
        margin: 20,
        dots: true,
        autoplay: true,
        responsive: {
            0: {
                items: 1
            },
            400: {
                items: 1
            },
            600: {
                items: 1
            },
            1000: {
                items: 2
            }
        }
    });

    // -----------------------------
    //  Story Slider
    // -----------------------------
    $('.about-slider').owlCarousel({
        loop: true,
        margin: 20,
        dots: true,
        autoplay: true,
        items: 1
    });

    // -----------------------------
    //  Quote Slider
    // -----------------------------
    $('.quote-slider').owlCarousel({
        loop: true,
        autoplay: true,
        items: 1
    });

    // -----------------------------
    //  Client Slider
    // -----------------------------
    $('.client-slider').owlCarousel({
        loop:true,
        autoplay:true,
        margin: 50,
        responsive:{
            0:{
                items:1,
                dots:false
            },
            400:{
                items:2,
                dots:false
            },
            600:{
                items:2,
                dots:false
            },
            1000:{
                items:4
            }
        }
    });
});


// WEBPACK FOOTER //
// ./js/parts/owl_carousels.js